'use client';

import { tv } from '@florencelabs/fabric-styles';
import { ReactElement } from 'react';
import { useFeatureFlags } from '@provider-directory/contexts/FlagContext';

const bannerStyle = tv({
  base: 'w-full py-2 px-4 flex justify-center items-center text-center print:hidden',
  variants: {
    bannerType: {
      WARNING: 'bg-amber-700 text-white',
      ERROR: 'bg-red-600 text-white',
      SUCCESS: 'bg-green-700 text-white',
      INFO: 'bg-blue-600 text-white',
    },
  },
  defaultVariants: {
    bannerType: 'INFO',
  },
});

export const TopBanner = (): ReactElement | null => {
  const { featureFlags, featureFlagPayloads } = useFeatureFlags();

  if (
    featureFlags.isTopBannerEnabled !== true ||
    !featureFlagPayloads.isTopBannerEnabled
  ) {
    return null;
  }

  const bannerPayload = featureFlagPayloads.isTopBannerEnabled;
  const message = bannerPayload.message;
  const bannerType = bannerPayload.type || 'INFO';

  return (
    <div className={bannerStyle({ bannerType })} data-testid={'top-banner'}>
      {message}
    </div>
  );
};

export default TopBanner;
